var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#565C65","fillRule":"evenodd","d":"M22.912 1.197A9.593 9.593 0 0 1 19.84 2.38 4.8 4.8 0 0 0 16.312.839c-2.667 0-4.832 2.188-4.832 4.885 0 .384.042.756.125 1.113-4.018-.204-7.58-2.147-9.965-5.106A4.919 4.919 0 0 0 .986 4.19c0 1.694.853 3.19 2.15 4.066a4.798 4.798 0 0 1-2.19-.609v.06c0 2.368 1.666 4.344 3.879 4.79a4.667 4.667 0 0 1-1.274.173c-.31 0-.615-.03-.91-.087.616 1.94 2.4 3.354 4.516 3.391a9.63 9.63 0 0 1-6.004 2.093c-.39 0-.776-.022-1.153-.067a13.598 13.598 0 0 0 7.41 2.194c8.893 0 13.754-7.445 13.754-13.902 0-.212-.004-.425-.013-.633a9.862 9.862 0 0 0 2.412-2.53 9.535 9.535 0 0 1-2.777.77 4.886 4.886 0 0 0 2.126-2.702"}));
}

Twitter.defaultProps = {"width":"24","height":"21","viewBox":"0 0 24 21"};

module.exports = Twitter;

Twitter.default = Twitter;
